<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card light>
        <v-card-text>
          <h6 class="text-xs-center">Indica la cantidad de puntos a Restar/Sumar para este Equipo</h6>
          <v-container fluid>
            <v-layout row>
              <v-flex xs2 class="text-xs-center">
                <v-btn @click="substractPoints()" color="red" fab flat small>
                    <v-icon color="red">remove</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  v-model="value"
                  type="number"
                  name="input-2"
                  :label="labelText"
                  light
                ></v-text-field>
              </v-flex>
              <v-flex xs2 class="text-xs-center">
                <v-btn @click="addPoints()" color="green" fab flat small>
                  <v-icon  color="green">add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid>
            <v-layout row>
                <v-flex xs12 class="text-xs-center">
                  <span>Cantidad de puntos originales: {{ realPoints }}</span>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs12 class="text-xs-center">
                  <v-btn color="primary" dark class="reset-points-button" @click.native="resetArbitraryPointsDialog()">
                    <v-icon dark right>delete</v-icon>
                    Reestablecer puntos originales
                  </v-btn>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="confirm(false)">{{ negativeText }}</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">{{ positiveText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'simple-numeric-input',
    props: {
      realPoints: { required: false, default: null },
      default: { required: false, default: 0 },
      dialog: { required: true, default: false },
      labelText: { required: false, default: "" },
      positiveText: { required: false, default: "Aceptar" },
      negativeText: { required: false, default: "Cancelar" }
    },
    data: function () {
      return {
        value: this.default
      }
    },
    watch:{
      default(newVal, oldVal){
        this.value = newVal
      }
    },
    methods: {
      confirm(response) {
        this.$emit('confirm', response, this.value);
      },
      resetArbitraryPointsDialog() {
        this.$emit('resetArbitraryPointsDialog');
      },
      substractPoints() {
        this.value -= 1;
      },
      addPoints() {
        this.value += 1;
      }
    }
}
</script>

<style lang="css" scoped>
  .reset-points-button {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpers/modals/SimpleNumericInput.vue